import { STATUS_CODE } from '@kc-console/core';

import { CookieKeyMap } from '../../../constants/cookie';
import { parseCookies } from '../../../utils/cookie/parseCookies';
import { getRequestUrlData } from '../../../utils/getRequestUrlData';
import { checkPasswordGuard } from './checkPasswordGuard';

import type { BaseState } from '@kc-console/context';
import type { Guard } from '../../../types';

/**
 * Settings 에서 서버사이드 라우트 이동 시 호출되어야하는 비밀번호 체크 가드
 * 라우트 이동 시의 state 객체에 token 및 domainId 가 없기 때문에, 쿠키 및 url 에서 값을 가져와 비밀번호 체크 로직을 진행합니다.
 */
export const checkPasswordRouteGuard: Guard<BaseState> = async ({
  state,
  context,
  queryClient,
}) => {
  const { status, iamSSREndpoint } = state;
  const { domainId } = getRequestUrlData(context);
  const cookies = parseCookies(context.req.headers.cookie || '');
  const token = cookies[CookieKeyMap.TOKEN_KEY] || '';

  if (status !== STATUS_CODE.OK) return { status };

  return await checkPasswordGuard({
    context,
    queryClient,
    status,
    token,
    domainId,
    iamEndpoint: iamSSREndpoint,
  });
};

checkPasswordRouteGuard.displayName = 'checkPasswordRouteGuard';
checkPasswordRouteGuard.traceCategory = 'authentication';
